import React from "react";
import { ShieldCheck, MapPin, Heart } from "lucide-react";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Uncompromised Safety",
    body: "Every caregiver is background-checked, CPR & First Aid certified, and rigorously vetted through a multi-stage interview process.",
    testid: "value-safety",
  },
  {
    icon: MapPin,
    title: "Ultimate Convenience",
    body: "We bring the care, activities, and full safety setup directly to your hotel, venue, or corporate event — nothing for you to arrange.",
    testid: "value-convenience",
  },
  {
    icon: Heart,
    title: "Tailored Experiences",
    body: "From gentle infant care to age-appropriate educational play for toddlers — every plan is custom-built around your child.",
    testid: "value-tailored",
  },
];

const ValueProp = () => {
  return (
    <section
      id="why-us"
      data-testid="value-prop-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-primary/80">
            Why Care Anywhere
          </div>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-foreground">
            We are the discreet, professional childcare parents, families and venues rely on when nothing but the best will do.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {PILLARS.map(({ icon: Icon, title, body, testid }, i) => (
            <div
              key={title}
              data-testid={testid}
              className="group relative p-8 lg:p-10 rounded-2xl bg-card border border-border/80 hover:border-primary/40 transition-all duration-300 hover:-translate-y-1 fade-up"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon size={24} className="text-primary group-hover:text-primary-foreground transition-colors" />
              </div>
              <h3 className="font-serif-display text-2xl text-foreground">
                {title}
              </h3>
              <p className="mt-4 text-muted-foreground leading-relaxed">
                {body}
              </p>
              <div className="mt-8 h-px w-12 bg-primary/40 group-hover:w-24 transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProp;
